import m2Sidebar from "@components/sidebar/m2_sidebar";
export default {
    components: {
        m2Sidebar
    },
    data() {
        return {
            batchDataList: [],
            auditStatus: {},
            payState: {
                succeed: 2,
            },
            region_nameStatus: false
        }
    },
    methods: {
        getData: function () {
            this.$http.get(globalProvider.serviceUrl('ex_exm/g/erb')).then((data) => {
                if (data.body.code === resultCode.Success) {
                    for (let i in data.body.data) {
                        if (data.body.data[i].list.length > 0) {
                            this.batchDataList.push(data.body.data[i])
                            // console.log(data.body.data[i].list[0][0])
                            if (data.body.data[i].list[0][0].items[0].region_name) {
                                this.region_nameStatus = true;
                            }
                        }
                    }
                } else if (data.body.code == resultCode.NotSuccess) {
                    this.$alert(getErrorMessage(data.body.message));
                }
            })
        },
        objectSpanMethod({
            row,
            column,
            rowIndex,
            columnIndex
        }) {
            if (columnIndex === 0 || columnIndex === 2 || columnIndex === 4 || columnIndex === 5 || columnIndex === 6) {
                if (rowIndex === 0) {
                    return {
                        rowspan: this.tableData.items.length,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        },
        modifyInfo: function (reg_id) {
            let reg_info_operation = 1;
            this.$confirm('考生修改信息后，请务必在【确认信息】页面提交报考信息', '注意', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.get(globalProvider.serviceUrl('ex_exm/g/eri/{reg_id}/{reg_info_operation}'), {
                    params: {
                        reg_id: reg_id,
                        reg_info_operation: reg_info_operation
                    }
                }).then((data) => {
                    if (data.body.code === resultCode.Success) {
                        this.$store.commit('setExamRegInfo', data.body.data);
                        this.getPromise()
                    } else if (data.body.code == resultCode.NotSuccess) {
                        if (data.body.message == 'EX_EMP_BLACK_01') {
                            this.$confirm(data.body.data, '提示', {
                                confirmButtonText: '确认',
                                type: "warning"
                            })
                        } else {
                            this.$alert(getErrorMessage(data.body.message));

                        }
                    }
                })
            }).catch(() => {
                return false
            });
        },
        setBatch() {
            this.$http.get(globalProvider.serviceUrl('ex_exm/g/bpe/{batch_id}'), {
                params: {
                    batch_id: this.batch_id
                }
            }).then((data) => {
                if (data.body.code === resultCode.Success) {
                    this.createRegId();
                } else if (data.body.code == resultCode.NotSuccess) {
                    this.$alert(getErrorMessage(data.body.message));
                }
            })
        },
        getPromise: function () {
            this.$http.get(globalProvider.serviceUrl('ex_exm/g/elc')).then((data) => {
                if (data.body.code == resultCode.Success) {
                    this.$store.commit('setPromiseState', data.body.data.status);
                    this.$router.push({
                        name: 'excuseExam.baseCollection'
                    });
                } else if (data.body.code == resultCode.NotSuccess) {
                    this.$alert(getErrorMessage(data.body.message), '提示', {
                        confirmButtonText: '确定'
                    });
                }
            });
        },
        toRegInfo(reg_id) {
            let reg_info_operation = 2;
            this.$http.get(globalProvider.serviceUrl('ex_exm/g/eri/{reg_id}/{reg_info_operation}'), {
                    params: {
                        reg_id: reg_id,
                        reg_info_operation: reg_info_operation
                    }
                })
                .then((data) => {
                    if (data.body.code === resultCode.Success) {
                        this.$store.commit('setExamRegInfo', data.body.data);
                        this.$router.push({
                            name: 'excuseExam.confirmRegInfo'
                        });
                    } else if (data.body.code == resultCode.NotSuccess) {
                        if (data.body.message == 'EX_EMP_BLACK_01') {
                            this.$confirm(data.body.data, '提示', {
                                confirmButtonText: '确认',
                                type: "warning"
                            })
                        } else {
                            this.$alert(getErrorMessage(data.body.message));

                        }
                    }
                })
        },
        objectSpanMethod({
            row,
            column,
            rowIndex,
            columnIndex
        }) {
            if (columnIndex === 0 || columnIndex === 2 || columnIndex === 5 || columnIndex === 6 || columnIndex === 4) {
                if (rowIndex == 0)
                    return {
                        rowspan: 100,
                        colspan: 1
                    };
                else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        }
    },
    created: function () {
        this.getData();
        this.auditStatus = auditStatus;
        this.$store.commit('setHeaderState', '0');
    }
}